import { render, staticRenderFns } from "./SampleTypeCreateEdit.vue?vue&type=template&id=e5131364&scoped=true&"
import script from "./SampleTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./SampleTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./SampleTypeCreateEdit.vue?vue&type=style&index=0&id=e5131364&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5131364",
  null
  
)

export default component.exports